// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"335":"a64f1cda","412":"a520b8cb","498":"eb47052c","513":"8891076e","703":"b13733cf","839":"5252f4c6","929":"1ac99b07"}[chunkId] + ".chunk.js";
};